import React from 'react';
import Popover from '@mui/material/Popover';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import './CustomReservedTableStatus.scss';
import moment from 'moment';

const CustomReservedTableStatus = (props) => {
  const { tableStatus, handleClose, onClickEdit, onClickRemoveReservation } = props;

  return (
    <Popover
      id={tableStatus.obj?.id}
      open={tableStatus.open}
      anchorEl={tableStatus.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      PaperProps={{ className: 'custom-reserved-table-status' }}
      className='custom-reserved-popover'
    >
      <div className='d-flex'>
        <div className='table-number'>
          <p className='table-number-title'>Table No</p>
          <p className='table-number-description'>{('0' + tableStatus.tableNumber).slice(-2)}</p>
        </div>
        <div className='divider-line'></div>
        <div className='reserved-table-details'>
          <div className='row'>
            <div className='col-md-6'>
              <p className='guest-details'>{tableStatus.obj.tableStatus}</p>
            </div>
            {tableStatus.obj.tableStatus !== 'Occupied' && (
              <div className='col-md-6 d-flex justify-content-end'>
                <div className='edit-circle' onClick={() => onClickEdit(tableStatus.obj)}>
                  <ModeEditIcon className='edit-circle-pencil' />
                </div>
              </div>
            )}
          </div>
          {tableStatus.obj.tableStatus !== 'Inactive' && (
            <>
              <p className='guest-details'>
                {tableStatus.obj.firstName} {tableStatus.obj.lastName}
              </p>
              <p className='guest-details'>
                {('0' + tableStatus.obj.noOfGuests).slice(-2)}{' '}
                {tableStatus.obj.noOfGuests > 1 ? 'Guests' : 'Guest'}
              </p>
            </>
          )}
          <p className='guest-details'>
            {moment(tableStatus.obj.reserveFrom, 'HH:mm').format('hh:mm A')} -{' '}
            {moment(tableStatus.obj.reserveUntil, 'HH:mm').format('hh:mm A')}
          </p>
          {tableStatus.obj.tableStatus !== 'Occupied' && (
            <p className='remove-reservation' onClick={() => onClickRemoveReservation(tableStatus)}>
              Remove Reservation
            </p>
          )}
        </div>
      </div>
    </Popover>
  );
};

export default CustomReservedTableStatus;
